import React from 'react';
import cx from 'classnames';
import {Flex, Text, Button} from '@priority-software/priority-style-react';
import texts from '../texts';
import styles from '../EmailVerification.module.scss';

type ConfirmationContentProps = {
    handleModalStep: (step: number, email?: string) => void;
};

export const ConfirmationContent = ({handleModalStep}: ConfirmationContentProps) => {
    return (
        <Flex direction="column" componentClasses={styles.content}>
            <Flex
                direction="column"
                alignItems="flex-start"
                componentClasses={styles.confirmationDesc}
            >
                <Text skin="paragraph-2">{texts.secondMessageDescP1}</Text>
                <Text>
                    <Text tag="span" skin="paragraph-2">
                        {texts.secondMessageDescP2}
                    </Text>
                    &nbsp;
                    <Text
                        tag="span"
                        skin="paragraph-2"
                        textColor="primary-500"
                        componentClasses={styles.emailLink}
                        onClick={() => handleModalStep(1)}
                    >
                        {texts.userEmail}
                    </Text>
                </Text>
            </Flex>
            <Flex direction="column" componentClasses={styles.confirmationFooter}>
                <Text skin="label-1">{texts.expirationText}</Text>
                <Button
                    size="medium"
                    onClick={() => handleModalStep(0)}
                    componentClasses={cx(styles.footerBtn, styles.confirmationBtn)}
                >
                    {texts.confirmBtn}
                </Button>
            </Flex>
        </Flex>
    );
};
